import { mensajes_chat } from "@/shared/dtos/chat/mensajes_chat";
import { Usuario } from "@/shared/dtos/usuario";

export class mensajes_chatAllData extends mensajes_chat {
  public texto_cabezera_mensaje!: string;
  public usuario!: Usuario;
  public es_mio!:boolean;
}
